import { render } from "./Markets.vue?vue&type=template&id=523a78f4&scoped=true"
import script from "./Markets.vue?vue&type=script&lang=js"
export * from "./Markets.vue?vue&type=script&lang=js"

import "./Markets.vue?vue&type=style&index=0&id=523a78f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523a78f4"]])

export default __exports__